/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-21 16:47:10
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-02 13:52:11
 */
import { createAsyncThunk } from "@reduxjs/toolkit"
import { send } from "../../app/appSlice"
import { AppThunkApi } from "../../app/store"
import {
  CountyRuleUserValue,
  CountyRuleValue,
  ErrorDistributionValue,
  OrganizationValue,
  ProvinceOverviewValue,
  ProvinceSaticValue,
  RegulatoryData,
  StaticValue,
  WarningRuleValue,
} from "../../models/Province"
import * as S from "../../services/Province"

// 地图数据，折线图数据
export const getProvinceMapAndAnaylseAndLastYaerData = createAsyncThunk<
  ProvinceSaticValue,
  string | undefined,
  AppThunkApi
>("Province/getProvinceData", async (code, api) => {
  return send(S.getProvinceMapAndAnaylseAndLastYaer(code), api).then((data) => {
    return {
      ...data,
      subAreaCountData: data.subAreaCountData.map((v: any) => {
        return {
          ...v,
          organizationTotal: v.acOrgTc,
        }
      }),
      userAreaCountData: {
        ...data.userAreaCountData,
        organizationTotal: data.userAreaCountData.acOrgTc,
      },
    }
  })
})

// 省监管数据总览
export const getProvinceOverviewData = createAsyncThunk<
  ProvinceOverviewValue[],
  S.ProvinceOverViewProps,
  AppThunkApi
>("Province/getOverviewData", async (params, api) => {
  return send(S.getProvinceOverview(params), api).then((data) => {
    return data.map((v: any) => {
      return {
        ...v,
        organizationTotal: v.acOrgTc,
      }
    })
  })
})

// 县监管数据总览
export const getCityOverview = createAsyncThunk<
  ProvinceOverviewValue[],
  S.ProvinceOverViewProps,
  AppThunkApi
>("Province/getOverviewData", async (params, api) => {
  return send(S.getCityOverview(params), api)
})

// 诊疗行为异常分布
export const getErrorDistributionData = createAsyncThunk<
  ErrorDistributionValue[],
  S.ErrorDistributionParams,
  AppThunkApi
>("Province/getErrorDistribution", async (params, api) => {
  return send(S.getErrorDistribution(params), api)
})

// 监管数据占比
export const getStaticData = createAsyncThunk<
  StaticValue[],
  S.StaticDataProps,
  AppThunkApi
>("Province/getStaticData", async (params, api) => {
  return send(S.getStaticData(params), api)
})

// 监管机构类型占比数据
export const getRegulatoryData = createAsyncThunk<
  RegulatoryData[],
  string | undefined,
  AppThunkApi
>("Province/getStaticData", async (params, api) => {
  return send(S.getRegulatoryData(params), api);
});

// 监管数据占比
export const getWarningRuleData = createAsyncThunk<
  WarningRuleValue[],
  S.WarningRuleProps,
  AppThunkApi
>("Province/getWarningData", async (params, api) => {
  return send(S.getWarningRuleData(params), api)
})

// 县平均处理时间占比
export const getCountyRuleData = createAsyncThunk<
  CountyRuleValue[],
  S.WarningRuleProps,
  AppThunkApi
>("Province/getCountyData", async (params, api) => {
  return send(S.getCountyRuleData(params), api)
})

// 县预警执法占比
export const getCountyRuleUseData = createAsyncThunk<
  CountyRuleUserValue[],
  S.CountyRuleUseProps,
  AppThunkApi
>("Province/getCountyData", async (params, api) => {
  return send(S.getCountyRuleUseData(params), api)
})

//接入结构
export const getOrganizationData = createAsyncThunk<
  OrganizationValue[],
  S.organizationProps,
  AppThunkApi
>("Province/getOrganizationData", async (params, api) => {
  return send(S.getOrganizationData(params), api).then((data) => {
    return data.map((v: any) => {
      return {
        ...v,
        accessTotal: v.acOrgTc,
        total: v.orgTc,
      }
    })
  })
})
